// extracted by mini-css-extract-plugin
export default {"wrap":"Expertise_wrap__fgyn5","grid":"Expertise_grid__CsHZd","category":"Expertise_category__-qc-E","items":"Expertise_items__v9Q1M"};